import ReCAPTCHA from "react-google-recaptcha";
import { createRef, useState } from "react";
import Button from "../button";
// import DropDownButton from "../dropdown";

const ContactUsForm = () => {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    selectedService: "",
    message: "",
  });

  const onChangeValue = (event) => {
    setForm({ ...form, [event.target.name]: event.target.value });
  };

  const recaptchaRef = createRef();
  const [captchaValue, setCaptchaValue] = useState(null);
  const [error, setError] = useState("");
  const onSubmit = (event) => {
    event.preventDefault();
    if (captchaValue === null) {
      setError((prev) => "I am not a robot");
      return;
    }

    console.log(form);
  };
  const onChange = () => {
    // console.log(value);
    const recaptchaValue = recaptchaRef.current.getValue();
    setCaptchaValue(recaptchaValue);
  };
  const onReset = () => {
    console.log("Capta Value Reset");
    setCaptchaValue(null);
  };

  // const serviceItems = ["Service 1", "Service 2", "Service 3", "Service 4"];
  // const [selectedServiceItem, setSelectedServiceItem] = useState(null);

  // const handleServiceItem = (index) => {
  //   console.log(index);
  //   setSelectedServiceItem((prev) => serviceItems[index]);
  // };
  return (
    <section className="space-y-16">
      <h1 className="text-center text-2xl font-semibold text-visBlue md:text-3xl">
        Send us a Message
      </h1>

      <form className="w-full" onSubmit={onSubmit}>
        <div className="-mx-3 mb-6 flex flex-wrap">
          <div className="mb-6 w-full px-3 md:mb-0 md:w-1/2">
            <label
              className="mb-2 block w-fit text-xs font-bold uppercase tracking-wide text-visBlue"
              htmlFor="first-name"
            >
              First Name*
            </label>

            <input
              onChange={onChangeValue}
              className="mb-3 block min-h-14 w-full appearance-none rounded border px-4 py-3 leading-tight text-gray-700 caret-visOrange outline-none transition-all duration-300 focus:border-visOrange focus:shadow-inputshadow"
              id="first-name"
              type="text"
              placeholder="Your first name"
              name="firstName"
            />
            {/* <p className="text-red-500 text-xs italic">Please fill out this field.</p> */}
          </div>
          <div className="w-full px-3 md:w-1/2">
            <label
              className="mb-2 block w-fit text-xs font-bold uppercase tracking-wide text-visBlue"
              htmlFor="last-name"
            >
              Last Name*
            </label>
            <input
              onChange={onChangeValue}
              className="mb-3 block min-h-14 w-full appearance-none rounded border px-4 py-3 leading-tight text-gray-700 caret-visOrange outline-none transition-shadow-border duration-300 focus:border-visOrange focus:shadow-inputshadow"
              id="last-name"
              type="text"
              placeholder="Your last name"
              name="lastName"
            />
          </div>
        </div>
        <div className="-mx-3 mb-6 flex flex-wrap">
          <div className="mb-6 w-full px-3 md:mb-0 md:w-1/2">
            <label
              className="mb-2 block w-fit text-xs font-bold uppercase tracking-wide text-visBlue"
              htmlFor="email"
            >
              Email address*
            </label>
            <input
              onChange={onChangeValue}
              className="mb-3 block min-h-14 w-full appearance-none rounded border px-4 py-3 leading-tight text-gray-700 caret-visOrange outline-none transition-shadow-border duration-300 focus:border-visOrange focus:shadow-inputshadow"
              id="email"
              type="text"
              placeholder="Enter your email"
              name="email"
            />
            {/* <p className="text-red-500 text-xs italic">Please fill out this field.</p> */}
          </div>
          {/* <div className="w-full px-3 md:w-1/2">
            <label
              className="mb-2 block w-fit text-xs font-bold uppercase tracking-wide text-visBlue"
              htmlFor="services"
            >
              Select Service*
            </label>
            <DropDownButton
              dropDownItems={serviceItems}
              selectedItem={selectedServiceItem}
              handleDropDown={handleServiceItem}
              setDropDownItem={setSelectedServiceItem}
            />
          </div> */}
        </div>
        <div className="-mx-3 mb-6 flex flex-wrap">
          <div className="mb-6 w-full px-3 md:mb-0">
            <label
              className="mb-2 block w-fit text-xs font-bold uppercase tracking-wide text-visBlue"
              htmlFor="message"
            >
              Your message*
            </label>
            <textarea
              onChange={onChangeValue}
              rows={"7"}
              className="mb-3 block w-full appearance-none rounded border px-4 py-3 leading-tight text-gray-700 caret-visOrange outline-none transition-shadow-border duration-300 focus:border-visOrange focus:shadow-inputshadow"
              id="message"
              type="text"
              placeholder="Enter your message here"
              name="message"
            />
            {/* <p className="text-red-500 text-xs italic">Please fill out this field.</p> */}
          </div>
        </div>
        <div className="flex flex-wrap items-center justify-between gap-5">
          <div className="overflow-hidden">
            <ReCAPTCHA
              // sitekey="6Lce5P8pAAAAAHKHSyHq7uXmWTDMa3QjzsSTXPEx"
              // secretKey="6Lce5P8pAAAAAJj10_DvQsrFh_CwvJASEnwCjnpl"
              ref={recaptchaRef}
              onReset={onReset}
              sitekey="6Lcy5P8pAAAAAE8RD42NnwtgrIer_82Uv6M2_-rq"
              className="origin-left scale-75 md:scale-100"
              onChange={onChange}
            />
            <small className="text-sm text-red-500">{error}</small>
          </div>

          <Button>
            <span className="px-6">Submit message</span>
          </Button>
        </div>
      </form>
    </section>
  );
};

export default ContactUsForm;
